export default __webpack_public_path__ + "static/media/journeytray-bluetree-fruitnutflower.4bcf31c4.svg";